export const ActionTypes = {
  REQUEST: "FETCH_LIST_CATEGORIES_REQUEST",
  SUCCESS: "FETCH_LIST_CATEGORIES_SUCCESS",
  FAILURE: "FETCH_LIST_CATEGORIES_FAILURE",
}
